<div class="title" [innerHTML]="'confirmationSendDialog_Data7' | i18n"></div>
<button [innerHTML]="'confirmationSendDialog_Data8' | i18n" (click)="closeDialog()"></button>
